import { useDispatch, useSelector } from "react-redux";
import { Transition } from "@headlessui/react";
import { Fragment } from "react";
import { TbWorld } from "react-icons/tb";

import { updateUserSettingsByUserID } from "actions/userSettings";

import useTheme from "hooks/useTheme";
import useNotification from "hooks/useNotification";

import ReactCountryFlag from "react-country-flag";
import SelectedDotIcon from "theme/icons/SelectedDot";

const Language = () => {
	const dispatch = useDispatch();

	const userSettings = useSelector((state) => state.UserSettings);

	const { appLanguage, themeColor } = useTheme();
	const { notify } = useNotification();

	const menuListIconStyle = `text-2xl ${themeColor?.text}`;

	const LanguagesList = [
		{
			icon: <ReactCountryFlag countryCode="gb" className={menuListIconStyle} svg />,
			"language-code": "en",
			language: appLanguage?.english,
		},
		{
			icon: <ReactCountryFlag countryCode="fr" className={menuListIconStyle} svg />,
			"language-code": "fr",
			language: appLanguage?.french,
		},
		{
			icon: <ReactCountryFlag countryCode="es" className={menuListIconStyle} svg />,
			"language-code": "es",
			language: appLanguage?.spanish,
		},
		{
			icon: <ReactCountryFlag countryCode="pt" className={menuListIconStyle} svg />,
			"language-code": "pt",
			language: appLanguage?.portuguese,
		},
		{
			icon: <ReactCountryFlag countryCode="de" className={menuListIconStyle} svg />,
			"language-code": "de",
			language: appLanguage?.german,
		},
	];

	return (
		<Transition
			as={Fragment}
			appear={true}
			show={true}
			enter="transition-opacity duration-500"
			enterFrom="opacity-0"
			enterTo="opacity-100"
		>
			<div className="items-center justify-content w-[50%] flex-col px-5 space-y-2">
				{/* <div className={`flex items-center w-full space-x-4 border-b-2 ${themeColor?.border}`}>
					<h1 className={`w-full text-xl font-bold ${themeColor?.text} pb-1`}>
						{appLanguage?.selectLanguage}
					</h1>
				</div> */}

				<div className={`flex flex-col w-full items-center justify-start space-y-3 py-3`}>
					{LanguagesList.map((languageItem, index) => (
						<div
							className={`flex w-full items-center justify-start space-x-4 cursor-pointer rounded-md border px-4 py-3`}
							key={index}
							onClick={() => {
								dispatch(updateUserSettingsByUserID({ "app-language": languageItem["language-code"] }, notify));
							}}
						>
							{languageItem?.icon}
							<p className={`w-full text-sm font-bold capitalize ${themeColor?.text}`}>{languageItem?.language}</p>
							{userSettings?.["app-language"]
								? userSettings["app-language"] === languageItem?.["language-code"] && (
										<SelectedDotIcon className={`w-4`} fill={themeColor?.hex} />
								  )
								: languageItem?.["language-code"] === "en" && (
										<SelectedDotIcon className={`w-4`} fill={themeColor?.hex} />
								  )}
						</div>
					))}
				</div>

				<div className={`flex flex-col w-full items-center justify-start space-y-3 py-3`}>
					<div
						className={`smooth flex items-start justify-center py-2 px-5 space-x-2 rounded-md ${themeColor?.text} hover:${themeColor?.bg} hover:text-gray-900 `}
					>
						<p className={`${themeColor?.text}`}>
							<TbWorld />
						</p>
						<p
							className={`w-full text-center text-sm font-medium ${themeColor?.text}`}
							dangerouslySetInnerHTML={{ __html: appLanguage?.suggestLanguage }}
						/>
					</div>
				</div>
			</div>
		</Transition>
	);
};

export default Language;
